import { useState, useEffect } from "react";

const COOKIE_NAME = "kuack_consent";

type ConsentStatus = "pending" | "accepted" | "rejected";

interface UseCookieConsentProps {
  onAccept?: () => void;
  onReject?: () => void;
}

export function useCookieConsent({ onAccept, onReject }: UseCookieConsentProps = {}) {
  const [status, setStatus] = useState<ConsentStatus>("pending");

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_NAME);
    if (consent === "accepted") {
      setStatus("accepted");
      onAccept?.();
    } else if (consent === "rejected") {
      setStatus("rejected");
      onReject?.();
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_NAME, "accepted");
    setStatus("accepted");
    onAccept?.();
  };

  const reject = () => {
    localStorage.setItem(COOKIE_NAME, "rejected");
    setStatus("rejected");
    onReject?.();
  };

  return {
    status,
    accept,
    reject,
  };
}
